import { OrderType } from "@app/constants";
import { GenericAbortSignal } from "axios";

export enum HttpMethod {
  GET = "GET",
  POST = "POST",
  PUT = "PUT",
  PATCH = "PATCH",
  DELETE = "DELETE",
}

export enum RequestContentType {
  MULTIPART = 1,
  BINARY_STREAM = 2,
}

export type Signal = GenericAbortSignal;

export interface HttpOptions {
  queryParams?: Record<string, ParamTypes>;
  body?: Record<string, unknown> | FormData | File;
  headers?: Record<string, unknown>;
  requestContentType?: RequestContentType;
  signal?: Signal;
  isShowLoading?: boolean;
}

type ParamTypes =
  | number
  | string
  | string[]
  | undefined
  | { [key: string]: any };

export interface RequestParams {
  pageNum?: number;
  pageSize?: number;
  sortType?: OrderType;
  sortBy?: string;
  keyword?: string;
}
